import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { coerceBoolean } from '@app-shared/decorators/coerce-boolean.decorator';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'btn-loading',
	templateUrl: './btn-loading.component.html',
	styleUrls: ['./btn-loading.component.scss']
})
export class BtnLoadingComponent implements OnInit {
	@coerceBoolean() @Input() squareRounded: boolean = false;
	@coerceBoolean() @Input() fillWidth: boolean = false;
	@coerceBoolean() @Input() disabled: boolean = false;
	@Input() loading: boolean;
	@Input() btnClass: string;
	@Input() spanClass: string;
	@Input() loadingText: string;
	@Input() type: 'button' | 'submit' = 'submit';
	@Input() loadingPosition: 'before' | 'after' = 'before';

	@HostBinding('style.width')
	get hostWidth() {
		return this.fillWidth ? '100%' : null;
	}

	@HostBinding('class.pe-none')
	get hostPeNone(): boolean {
		return this.loading || this.disabled;
	}

	constructor() {}

	ngOnInit() {}
}
